module.exports = __webpack_public_path__ + "img/0118.514c7966.png";